// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1sxC6","fileBtn":"File_fileBtn__1Ow1t","closeBtn":"File_closeBtn__1-Sq4","fileSelected":"File_fileSelected__173bW","disabled":"File_disabled__1Pvaa"};